module.exports = __webpack_public_path__ + "static/ToolkitLandingImg1-6a90b677d4088571ad97edfeca49414a.png";